//CONSTANTS
import {
  GET_RISK_SUCCESS,
  GET_RISK_NO_ARCHIVE_SUCCESS,
  GET_RISK_BY_ID_SUCCESS,
  GET_RISK_BY_MAPPING_RISK_ID_SUCCESS,
  SET_LIST_RISK_ASSOCIATED,
  // RISK RESIDUAL
  GET_RISK_RESIDUAL_SUCCESS,
  GET_RISK_RESIDUAL_BY_ID_SUCCESS,
  //Mapping Risks
  GET_MAPPING_RISK_SUCCESS,
  GET_MAPPING_RISK_BY_ID_SUCCESS,
  GET_HISTORIC_OF_MAPPING_RISK_BY_ID_SUCCESS,
  // MATRICE DES RISQUES
  GET_FRENQUENCIES_AND_IMPACTS_SUCCESS,
  GET_MATRICE_RISK_SUCCESS,
  GET_MATRICE_RISK_BY_ID_SUCCESS,
  GET_CALCUL_RISK_BRUT_RESULT_SUCCESS,
  // ECHELLE DE CONFORMITE
  GET_CONFORMITY_SCALE_SUCCESS,
  GET_CONFORMITY_SCALE_BY_CONTROL_SUCCESS,
} from "../Risks/constants.js"

const initialState = {
  riskList: [],
  riskSelect: {},
  riskResidualList: [],
  riskResidualSelect: {},
  mappingRiskList: [],
  mappingRiskSelect: [],
  historicOfActualMappingRisk: [],
  matriceRisk: [],
  matriceRiskById: {},
  frequenciesAndImpacts: {},
  calculRiskBrutResult: {},
  listRiskAssociated: [],
  conformityScales: [],
  conformityScalesByControl: {},
}

function riskDataReducer(state = initialState, { type, payload }) {
  switch (type) {
    //**************************************************************************
    //*************************** REDUCER RISK *********************************
    //**************************************************************************
    //******************** Risk *******************
    case GET_RISK_SUCCESS:
    case GET_RISK_NO_ARCHIVE_SUCCESS:
      return {
        ...state,
        riskList: payload,
      }
    case GET_RISK_BY_ID_SUCCESS:
      return {
        ...state,
        riskSelect: payload,
      }
    case GET_RISK_BY_MAPPING_RISK_ID_SUCCESS:
    case SET_LIST_RISK_ASSOCIATED:
      return {
        ...state,
        listRiskAssociated: payload,
      }
    //******************** Risk Residual *******************
    case GET_RISK_RESIDUAL_SUCCESS:
      return {
        ...state,
        riskResidualList: payload,
      }
    case GET_RISK_RESIDUAL_BY_ID_SUCCESS:
      return {
        ...state,
        riskResidualSelect: payload,
      }
    //******************** Mapping Risk *******************
    case GET_MAPPING_RISK_SUCCESS:
      return {
        ...state,
        mappingRiskList: payload,
      }
    case GET_MAPPING_RISK_BY_ID_SUCCESS:
      return {
        ...state,
        mappingRiskSelect: payload,
      }
    case GET_HISTORIC_OF_MAPPING_RISK_BY_ID_SUCCESS:
      return { ...state, historicOfActualMappingRisk: payload }
    //******************** Matrice Risk *******************
    case GET_MATRICE_RISK_SUCCESS:
      return {
        ...state,
        matriceRisk: payload,
      }
    case GET_MATRICE_RISK_BY_ID_SUCCESS:
      return {
        ...state,
        matriceRiskById: payload,
      }
    case GET_CALCUL_RISK_BRUT_RESULT_SUCCESS:
      return {
        ...state,
        calculRiskBrutResult: payload?.riskBrutResult,
      }
    case GET_FRENQUENCIES_AND_IMPACTS_SUCCESS:
      return {
        ...state,
        frequenciesAndImpacts: payload,
      }
    //***************** Echelle de conformité *******************
    case GET_CONFORMITY_SCALE_SUCCESS:
      return {
        ...state,
        conformityScales: payload,
      }
    case GET_CONFORMITY_SCALE_BY_CONTROL_SUCCESS:
      return {
        ...state,
        conformityScalesByControl: payload,
      }
    default:
      return state
  }
}

export default riskDataReducer
